/*
----------------------------
Module - header
----------------------------
*/

import $ from 'jquery';
/*global fmg*/

(function(){
    'use strict';

    fmg.header = function () {

        function checkPositionOfStickyMobileHeader() {

            // Get current position of where the top of the viewport the user is at
            var docViewTop = $(window).scrollTop();
                
            // Position of header may change at any time e.g. global alerts removed and mobile header moves up
            var headerOffsetTop = $header.offset().top;
            var headerHeight = $header.height();

            // Get position of where top of the main is
            var mainOffsetTop = $main.offset().top;

            // If top of viewport is past where the relative position of top of the header is, make position fixed
            if (docViewTop > headerOffsetTop) {

                $header.addClass("header--sticky"); // Make header stick to the top
                $main.css("padding-top", headerHeight); // Need to add padding so that the content doesn't "jump"

            } else if (docViewTop <= mainOffsetTop) {

                // If top of viewport is at or before where the top of main + padding, make position of header relative
                // This is because alerts might live above the header so we need to lock the header back in place
                resetMobileHeaderPosition();

            }
            
        }

        function resetMobileHeaderPosition() {
            $header.removeClass("header--sticky");
            $main.css("padding-top", 0);
        }

        var scrolledEvent = fmg.fn.debounce(function() {

            checkPositionOfStickyMobileHeader();
            
        }, 10);

        function toggleStickyMobileHeader() {
            
            checkPositionOfStickyMobileHeader();

            $(window).on("scroll", scrolledEvent); // Bind scroll event

        }

        function disableStickyMobileHeader() {
            
            resetMobileHeaderPosition();

            $(window).off('scroll', scrolledEvent);
        }

        // When the viewport is changed, this function is called from global.js in the _global module
        function refresh() {

            if (fmg.vars.screensize < 4) {
                toggleStickyMobileHeader();
            } else {
                disableStickyMobileHeader();
            }

        }

        function init() {

            $header = $(".header");
            $main = $("main");

        }

        var $header;
        var $main;

        return {
            init: init,
            refresh: refresh
        };

    }();

    document.addEventListener("DOMContentLoaded", function () {
        fmg.header.init();
    });

}());
